import { Button } from 'blaze-ui/Button'
import { ArrowRefresh2 } from 'blaze-ui/icons'

interface Props {
  onRegenerate: () => void
}

export const RegenerateButton = ({ onRegenerate }: Props) => {
  return (
    <Button onPress={onRegenerate} variant="secondary" size="md" fullWidth frontIcon={ArrowRefresh2}>
      Generate
    </Button>
  )
}
